import React, { useState } from 'react';
import InventoryTransactionForm from './InventoryTransactionForm';
import InventoryHistory from './InventoryHistory';
import './InventoryTabs.css';

interface InventoryTabsProps {
  productId: string;
  productName: string;
  variantId: string;
  variantAttributes?: Record<string, string>;
  unitId: string;
  unitName: string;
  onTransactionComplete: () => void;
}

const InventoryTabs: React.FC<InventoryTabsProps> = ({
  productId,
  productName,
  variantId,
  variantAttributes,
  unitId,
  unitName,
  onTransactionComplete
}) => {
  // State to keep track of active tab
  const [activeTab, setActiveTab] = useState<'transactions' | 'history'>('transactions');

  // Handle tab click
  const handleTabClick = (tab: 'transactions' | 'history') => {
    setActiveTab(tab);
  };

  return (
    <div className="inventory-tabs">
      <ul className="inventory-tab-list">
        <li 
          className={`inventory-tab ${activeTab === 'transactions' ? 'active' : ''}`}
          onClick={() => handleTabClick('transactions')}
        >
          <span>إضافة / خصم</span>
        </li>
        <li 
          className={`inventory-tab ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => handleTabClick('history')}
        >
          <span>سجل الحركة</span>
        </li>
      </ul>
      
      <div className={`inventory-tab-content ${activeTab === 'transactions' ? 'active' : ''}`}>
        <InventoryTransactionForm
          productId={productId}
          productName={productName}
          variantId={variantId}
          variantAttributes={variantAttributes}
          unitId={unitId}
          unitName={unitName}
          onTransactionComplete={onTransactionComplete}
        />
      </div>
      
      <div className={`inventory-tab-content ${activeTab === 'history' ? 'active' : ''}`}>
        <InventoryHistory
          productId={productId}
          productName={productName}
          variantId={variantId}
        />
      </div>
    </div>
  );
};

export default InventoryTabs;